import { formatDateShort } from '@ozgene/gp5.utils.date-functions';
import PropTypes from 'prop-types';

function DateFormatter(props) {
  const { value } = props;
  const text = formatDateShort(value);

  return value && (text === 'Invalid Date' ? value : text);
}

DateFormatter.propTypes = {
  value: PropTypes.string.isRequired,
};

export default DateFormatter;
